/* Mobile menu burger toggle */
(function () {
    const navigation = document.querySelector('.gh-navigation');
    if (!navigation) return;
    const burger = navigation.querySelector('.gh-burger');
    if (!burger) return;

    burger.addEventListener('click', function () {
        if (!navigation.classList.contains('is-open')) {
            navigation.classList.add('is-open');
            document.documentElement.style.overflowY = 'hidden';
        } else {
            navigation.classList.remove('is-open');
            document.documentElement.style.overflowY = null;
        }
    });
})();

/* Move navigation one-to-one with page scroll in either direction */
(function () {
    const navigation = document.querySelector('[data-scroll-header]');
    if (!navigation) return;

    const root = document.documentElement;
    let previousScroll = getScrollPosition();
    let navigationHeight = navigation.offsetHeight;
    let navigationOffset = -Math.min(previousScroll, navigationHeight);
    let frame = null;

    function getScrollPosition() {
        const maxScroll = Math.max(root.scrollHeight - window.innerHeight, 0);
        return Math.min(Math.max(window.scrollY, 0), maxScroll);
    }

    function shouldStayVisible() {
        return navigation.classList.contains('is-open')
            || navigation.contains(document.activeElement);
    }

    function setNavigationOffset(offset) {
        navigationOffset = Math.min(Math.max(offset, -navigationHeight), 0);
        navigation.style.setProperty('--navigation-scroll-y', navigationOffset.toFixed(2) + 'px');
    }

    function updateNavigationHeight() {
        const wasHidden = navigationHeight > 0 && navigationOffset <= -navigationHeight;
        navigationHeight = navigation.offsetHeight;
        root.style.setProperty('--navigation-height', navigationHeight + 'px');

        // A layout change is not a scroll gesture. Keep the current exposure,
        // or the fully hidden edge, within the new measured height.
        previousScroll = getScrollPosition();
        setNavigationOffset(shouldStayVisible() || previousScroll === 0
            ? 0
            : wasHidden ? -navigationHeight : navigationOffset);
    }

    function update() {
        const currentScroll = getScrollPosition();
        const delta = currentScroll - previousScroll;

        navigation.classList.toggle('is-scrolled', currentScroll > 8);
        setNavigationOffset(currentScroll === 0 || shouldStayVisible()
            ? 0
            : navigationOffset - delta);

        previousScroll = currentScroll;
        frame = null;
    }

    function requestUpdate() {
        if (frame === null) frame = window.requestAnimationFrame(update);
    }

    function syncVisibility() {
        // Discard travel accumulated while focus or the menu held the header.
        previousScroll = getScrollPosition();
        if (shouldStayVisible()) setNavigationOffset(0);
        requestUpdate();
    }

    function resetPosition() {
        updateNavigationHeight();
        setNavigationOffset(shouldStayVisible() ? 0 : -Math.min(previousScroll, navigationHeight));
        requestUpdate();
    }

    navigation.addEventListener('focusin', syncVisibility);
    navigation.addEventListener('focusout', syncVisibility);
    const burger = navigation.querySelector('.gh-burger');
    if (burger) {
        // The menu toggle above runs first; no scroll event is needed to pin it.
        burger.addEventListener('click', function () {
            updateNavigationHeight();
            syncVisibility();
        });
    }
    window.addEventListener('scroll', requestUpdate, {passive: true});
    window.addEventListener('resize', function () {
        updateNavigationHeight();
        requestUpdate();
    });
    window.addEventListener('pageshow', resetPosition);

    if ('ResizeObserver' in window) {
        const navigationObserver = new ResizeObserver(updateNavigationHeight);
        navigationObserver.observe(navigation);
    }

    resetPosition();
})();


/* Reveal the compact footer as a darker layer behind the page */
(function () {
    const footer = document.querySelector('[data-footer-reveal]');
    const pageLayer = document.querySelector('[data-page-layer]');
    if (!footer || !pageLayer) return;

    const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
    let frame = null;

    function update() {
        const footerRect = footer.getBoundingClientRect();
        const pageLayerRect = pageLayer.getBoundingClientRect();
        const visibleHeight = Math.min(Math.max(window.innerHeight - pageLayerRect.bottom, 0), footerRect.height);
        const progress = footerRect.height ? visibleHeight / Math.min(footerRect.height, window.innerHeight) : 1;
        const offset = reducedMotion.matches ? 0 : (1 - progress) * 48;
        footer.style.setProperty('--footer-parallax-y', offset.toFixed(2) + 'px');
        frame = null;
    }

    function requestUpdate() {
        if (frame === null) frame = window.requestAnimationFrame(update);
    }

    window.addEventListener('scroll', requestUpdate, {passive: true});
    window.addEventListener('resize', requestUpdate);
    if (reducedMotion.addEventListener) {
        reducedMotion.addEventListener('change', requestUpdate);
    }
    update();
})();

/* Shared hero depth, disabled when the visitor requests less motion */
(function () {
    const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
    if (reducedMotion.matches) return;

    const targets = [
        {
            hero: document.querySelector('.gh-brand-hero:not(.gh-subscribe-layout)'),
            mediaSelector: '.gh-brand-hero-media',
            property: '--hero-parallax-y',
        },
        {
            hero: document.querySelector('[data-article-hero]'),
            mediaSelector: '[data-article-hero-media]',
            property: '--article-parallax-y',
        },
    ].map(function (target) {
        return {
            hero: target.hero,
            media: target.hero && target.hero.querySelector(target.mediaSelector),
            property: target.property,
        };
    }).filter(function (target) {
        return target.hero && target.media;
    });

    if (!targets.length) return;

    let frame = null;

    function update() {
        const mobile = window.matchMedia('(max-width: 767px)').matches;
        const strength = mobile ? 0.18 : 0.32;
        const minimum = mobile ? -14 : -22;
        const maximum = mobile ? 68 : 132;

        targets.forEach(function (target) {
            const rect = target.hero.getBoundingClientRect();
            const offset = Math.min(Math.max(-rect.top * strength, minimum), maximum);
            target.media.style.setProperty(target.property, offset.toFixed(2) + 'px');
        });

        frame = null;
    }

    function requestUpdate() {
        if (frame === null) frame = window.requestAnimationFrame(update);
    }

    window.addEventListener('scroll', requestUpdate, {passive: true});
    window.addEventListener('resize', requestUpdate);
    update();
})();

/* Article feature-image reveal */
(function () {
    const hero = document.querySelector('[data-article-hero]');
    const media = hero && hero.querySelector('[data-article-hero-media]');
    const image = media && media.querySelector('img');
    if (!hero || !media) return;

    function revealImage() {
        hero.classList.add('is-initialized');
    }

    if (!image || image.complete) {
        revealImage();
    } else {
        image.addEventListener('load', revealImage, {once: true});
        image.addEventListener('error', revealImage, {once: true});
    }

})();

/* Add lightbox to gallery images */
(function () {
    lightbox(
        '.kg-image-card > .kg-image, .kg-gallery-image > img'
    );
})();

/* Promote a standalone YouTube URL to a wide, privacy-enhanced embed */
(function () {
    const paragraphs = document.querySelectorAll('.gh-content > p');

    function videoId(value) {
        try {
            const url = new URL(value);
            const host = url.hostname.toLowerCase().replace(/^www\./, '');
            const parts = url.pathname.split('/').filter(Boolean);
            if (host === 'youtu.be') return parts[0] || '';
            if (host !== 'youtube.com' && host !== 'm.youtube.com') return '';
            if (url.pathname === '/watch') return url.searchParams.get('v') || '';
            return ['embed', 'shorts', 'live'].includes(parts[0]) ? parts[1] || '' : '';
        } catch (error) {
            return '';
        }
    }

    paragraphs.forEach(function (paragraph) {
        if (paragraph.children.length !== 1 || paragraph.firstElementChild?.tagName !== 'A') return;
        const link = paragraph.firstElementChild;
        if (paragraph.textContent.trim() !== link.href && paragraph.textContent.trim() !== link.textContent.trim()) return;
        const id = videoId(link.href);
        if (!/^[a-zA-Z0-9_-]{6,}$/.test(id)) return;

        const card = document.createElement('figure');
        card.className = 'kg-card kg-embed-card kg-width-wide';
        const iframe = document.createElement('iframe');
        iframe.src = 'https://www.youtube-nocookie.com/embed/' + id;
        iframe.title = 'YouTube video player';
        iframe.loading = 'lazy';
        iframe.allow = 'accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share';
        iframe.referrerPolicy = 'strict-origin-when-cross-origin';
        iframe.allowFullscreen = true;
        card.appendChild(iframe);
        paragraph.replaceWith(card);
    });
})();

/* Responsive video in post content */
(function () {
    const sources = [
        '.gh-content iframe[src*="youtube.com"]',
        '.gh-content iframe[src*="youtube-nocookie.com"]',
        '.gh-content iframe[src*="player.vimeo.com"]',
        '.gh-content iframe[src*="kickstarter.com"][src*="video.html"]',
        '.gh-content object',
        '.gh-content embed',
    ];
    reframe(document.querySelectorAll(sources.join(',')));
})();

/* Turn the main nav into dropdown menu when there are more than 5 menu items */
(function () {
    dropdown();
})();

/* Infinite scroll pagination */
(function () {
    if (!document.body.classList.contains('home-template') && !document.body.classList.contains('post-template')) {
        pagination();
    }
})();

/* Responsive HTML table */
(function () {
    const tables = document.querySelectorAll('.gh-content > table:not(.gist table)');
    
    tables.forEach(function (table) {
        const wrapper = document.createElement('div');
        wrapper.className = 'gh-table';
        table.parentNode.insertBefore(wrapper, table);
        wrapper.appendChild(table);
    });
})();

/* Add an accessible copy control to native Ghost and imported code blocks */
(function () {
    const codeBlocks = document.querySelectorAll('.gh-content pre > code');

    function icon(type) {
        if (type === 'check') {
            return '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="m5 12 4 4L19 6"/></svg>';
        }
        if (type === 'wrap') {
            return '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M4 6h16M4 11h11a4 4 0 0 1 0 8h-2"/><path d="m16 16-3 3 3 3M4 16h5"/></svg>';
        }
        return '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><rect width="14" height="14" x="8" y="8" rx="2" ry="2"/><path d="M4 16c-1.1 0-2-.9-2-2V4c0-1.1.9-2 2-2h10c1.1 0 2 .9 2 2"/></svg>';
    }

    function setButtonState(button, state) {
        const copied = state === 'copied';
        const failed = state === 'failed';
        const label = copied ? 'Copied' : failed ? 'Copy failed' : 'Copy';
        button.classList.toggle('is-copied', copied);
        button.innerHTML = icon(copied ? 'check' : 'copy')
            + '<span class="gh-code-copy-label">' + label + '</span>';
        button.setAttribute('aria-label', copied ? 'Code copied' : failed ? 'Copy failed' : 'Copy code');
        button.setAttribute('title', label);
    }

    function fallbackCopy(text) {
        let eventHandled = false;
        function handleCopy(event) {
            if (!event.clipboardData) return;
            event.preventDefault();
            event.clipboardData.setData('text/plain', text);
            eventHandled = true;
        }

        const textarea = document.createElement('textarea');
        textarea.value = text;
        textarea.setAttribute('readonly', '');
        textarea.style.position = 'fixed';
        textarea.style.left = '-9999px';
        textarea.style.opacity = '0';
        document.body.appendChild(textarea);
        textarea.focus();
        textarea.select();
        textarea.setSelectionRange(0, textarea.value.length);
        document.addEventListener('copy', handleCopy, {once: true});
        const copied = document.execCommand('copy') && eventHandled;
        document.removeEventListener('copy', handleCopy);
        textarea.remove();
        return copied;
    }

    async function copyText(text) {
        if (navigator.clipboard && window.isSecureContext) {
            await navigator.clipboard.writeText(text);
            return;
        }
        if (fallbackCopy(text)) return;
        throw new Error('Copy command failed');
    }

    codeBlocks.forEach(function (code) {
        const pre = code.parentElement;
        if (!pre || pre.closest('.gh-code-block')) return;

        const wrapper = document.createElement('div');
        wrapper.className = 'gh-code-block';
        pre.parentNode.insertBefore(wrapper, pre);
        wrapper.appendChild(pre);

        const actions = document.createElement('div');
        actions.className = 'gh-code-actions';
        wrapper.appendChild(actions);

        const button = document.createElement('button');
        button.className = 'gh-code-copy';
        button.type = 'button';
        button.setAttribute('aria-live', 'polite');
        setButtonState(button, 'idle');

        let copyResetTimeout;
        button.addEventListener('click', async function () {
            window.clearTimeout(copyResetTimeout);
            try {
                await copyText(code.textContent || '');
                setButtonState(button, 'copied');
            } catch (error) {
                setButtonState(button, 'failed');
            }
            copyResetTimeout = window.setTimeout(function () {
                setButtonState(button, 'idle');
            }, 2000);
        });

        actions.appendChild(button);

        const wrapButton = document.createElement('button');
        wrapButton.className = 'gh-code-wrap is-active';
        wrapButton.type = 'button';
        wrapButton.innerHTML = icon('wrap');
        wrapButton.setAttribute('aria-label', 'Disable line wrapping');
        wrapButton.setAttribute('title', 'Disable line wrapping');
        wrapButton.setAttribute('aria-pressed', 'true');
        wrapButton.addEventListener('click', function () {
            const wrapping = wrapper.classList.toggle('is-nowrap') === false;
            wrapButton.classList.toggle('is-active', wrapping);
            wrapButton.setAttribute('aria-label', wrapping ? 'Disable line wrapping' : 'Enable line wrapping');
            wrapButton.setAttribute('title', wrapping ? 'Disable line wrapping' : 'Enable line wrapping');
            wrapButton.setAttribute('aria-pressed', wrapping ? 'true' : 'false');
        });
        actions.insertBefore(wrapButton, button);

        const codeStyle = window.getComputedStyle(code);
        const preStyle = window.getComputedStyle(pre);
        const lineHeight = Number.parseFloat(codeStyle.lineHeight) || Number.parseFloat(codeStyle.fontSize) * 1.55;
        const verticalPadding = (Number.parseFloat(preStyle.paddingTop) || 0) + (Number.parseFloat(preStyle.paddingBottom) || 0);
        const collapsedHeight = lineHeight * 3 + verticalPadding;
        const hasMoreThanThreeVisualLines = pre.scrollHeight > collapsedHeight + 1;

        if (hasMoreThanThreeVisualLines) {
            wrapper.classList.add('is-collapsible');

            const expandButton = document.createElement('button');
            expandButton.className = 'gh-code-expand';
            expandButton.type = 'button';
            expandButton.textContent = 'Expand';
            expandButton.setAttribute('aria-expanded', 'false');
            expandButton.addEventListener('click', function () {
                const expanded = wrapper.classList.toggle('is-expanded');
                expandButton.textContent = expanded ? 'Collapse' : 'Expand';
                expandButton.setAttribute('aria-expanded', expanded ? 'true' : 'false');
            });
            wrapper.appendChild(expandButton);
        }
    });
})();

/* Keep footer copyright current without requiring a yearly theme release. */
(function () {
    document.querySelectorAll('[data-current-year]').forEach(function (element) {
        element.textContent = String(new Date().getFullYear());
    });
})();
